import { type TileIndex } from "@/types/tile";
import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class TanneryBuildingTileEntity extends TileEntity {
	public static readonly frameName = FrameName.TANNERY;

	public get suppliesTileIndexes(): Set<TileIndex> {
		// zasobuje len 1 tailors workshop a 1 shoemaker
		const uniqueByFrameName = Array.from(super.suppliesTileIndexes)
			.map(
				(
					tileIndex: TileIndex,
				): { tileIndex: TileIndex; frameName: FrameName } | null => {
					const tileId =
						this.tilerepo.getTileIdByTileIndex(tileIndex);
					if (!tileId) return null;

					const frameName =
						this.tilerepo.getFrameNameByTileId(tileId);
					if (!frameName) return null;

					return { tileIndex, frameName };
				},
			)
			.filter(
				(
					item: { tileIndex: TileIndex; frameName: FrameName } | null,
					index: number,
					array: Array<{
						tileIndex: TileIndex;
						frameName: FrameName;
					} | null>,
				): boolean =>
					!!item &&
					index ===
						array.findIndex(
							(
								i: {
									tileIndex: TileIndex;
									frameName: FrameName;
								} | null,
							): boolean => !!i && i.frameName === item.frameName,
						),
			)
			.map(
				(
					item: { tileIndex: TileIndex; frameName: FrameName } | null,
				): TileIndex => item!.tileIndex,
			);

		return new Set<TileIndex>(uniqueByFrameName);
	}
}

export default TanneryBuildingTileEntity;
